<template>
  <div class="clients-stat-diagram-container">
    <div class="header-container">
      <div class="title">{{ $t("navbar.stats_guests") }}</div>
      <div class="mode-slider">
        <div
          @click="ChangeMode('day')"
          :class="{ 'mode-slide-btn': true, 'active-mode': mode == 'day' }"
        >
          {{ $t("stats_chart.day") }}
        </div>
        <div
          @click="ChangeMode('week')"
          :class="{ 'mode-slide-btn': true, 'active-mode': mode == 'week' }"
        >
          {{ $t("stats_chart.week") }}
        </div>
        <div
          @click="ChangeMode('month')"
          :class="{ 'mode-slide-btn': true, 'active-mode': mode == 'month' }"
        >
          {{ $t("stats_chart.month") }}
        </div>
      </div>
    </div>
    <div class="histogram">
      <div class="histogram-bg">
        <div v-for="i in 10" :key="i" class="histogram-line">
          {{ Math.round((maxValue - (i - 1) * (maxValue / 11)) * 10) / 10 }}
          <div></div>
        </div>
        <div class="histogram-line">
          0
          <div></div>
        </div>
      </div>
      <div :class="{ 'histogram-data-container': true }">
        <div
          @click="selected_entry = entry"
          v-for="entry in renderableDataset"
          :key="entry.timestamp"
          :class="`histogram-data-column ${selected_entry == entry ? 'active' : ''} ${
            mode != 1 ? 'big-mode' : ''
          }`"
        >
          <div class="bottom-part">
            <div
              class="data-col"
              :style="`height:${entry.total_height * 0.3566666666}vh`"
            >
              <div class="inner-data-col" :style="`height:${entry.sub_height}%`"></div>
            </div>
          </div>
          <div class="day-lable" :class="{
            'day-off': entry.day_off
          }">
            {{ entry.label }}
          </div>
          <div class="day-date">
            {{ entry.sublabel }}
          </div>
        </div>
      </div>
    </div>
    <div class="selected-details">
      <div class="details-title">
        {{ selectedEntryDate}}
      </div>
      <div class="stat-row">
        <div class="info-block">
          <div class="lable">Кількість гостей</div>
          <div class="value">
            {{ selected_entry.total_guests || 0 }}
          </div>
        </div>
        <div class="info-block">
          <div class="lable">Постійні</div>
          <div class="value">
            {{ selected_entry.old_guests || 0 }}
          </div>
        </div>
        <div class="info-block">
          <div class="lable">Нові</div>
          <div class="value">
            {{ selected_entry.new_guests || 0}}
          </div>
        </div>
        <div class="info-block">
          <div class="lable">Середньостатистичний показник</div>
          <div class="value">
            {{ averageValue || 0}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  data() {
    return {
      mode: "day",

      selected_entry: null,
    };
  },
  props: {
    chart: Object,
  },
  methods: {
    ChangeMode(mode) {
      this.mode = mode;
    },
    setActive(active) {
      this.active = active;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.selected_entry = this.renderableDataset[0];
    });
  },
  computed: {
    selectedEntryDate() {
      return moment(this.selected_entry.timestamp).format('dddd, DD.MM');
    },
    targetDataset() {
      return this.chart[this.mode];
    },
    averageValue() {
      const total = this.targetDataset.reduce((acc,item) => acc + item.total_guests , 0);
      const count = this.targetDataset.filter((day) => day.total_guests).length;
      if (!this.targetDataset.length) return 0;

      return Math.round(total / count);
    },
    maxValue() {
      return this.targetDataset.reduce((acc,item) => acc < item.total_guests ? item.total_guests : acc, 0);
    },
    renderableDataset() {
      return this.targetDataset.map((d) => {
        const ret_val = { ...d };

        if (this.mode == "day") {
          ret_val.label = moment(d.timestamp).format("ddd");
          ret_val.sublabel = moment(d.timestamp).format("DD.MM");
        } else if (this.mode == "week") {
          ret_val.label = moment(d.timestamp).startOf("week").format("ddd") +
            " - " +
            moment(d.timestamp).endOf("week").format("ddd");
          ret_val.sublabel =
            moment(d.timestamp).startOf("week").format("DD.MM") +
            " - " +
            moment(d.timestamp).endOf("week").format("DD.MM");
        } else if (this.mode == "month") {
          ret_val.label = moment(d.timestamp).format("MMM");
          ret_val.sublabel =
            moment(d.timestamp).format("DD.MM") +
            " - " +
            moment(d.timestamp).endOf("month").format("DD.MM");
        }

        if (this.mode =='day') ret_val.day_off = [0,6].includes(moment(d.timestamp).day());

        ret_val.total_height = Math.round(
          ret_val.total_guests * 100 / this.maxValue
        ) || 0;

        ret_val.sub_height = Math.round(
          ret_val.new_guests * 100 / ret_val.total_guests
        );

        return ret_val;
      });
    },
  },
};
</script>
<style scoped>
.clients-stat-diagram-container {
  width: 100%;
  padding: 2.222vh;
  background: #e5e5e5;
  border-radius: 1.333vh;
  margin-top: 3.333vh;
  box-sizing: border-box;
}
.header-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2.222vh;
}
.title {
  font-size: 2.777vh;
  line-height: 3.222vh;
  display: flex;
  align-items: center;
  color: #908f8d;
}
.mode-slider {
  height: 3.666h;
  background: #ededed;
  border-radius: 0.444vh;
  display: flex;
}
.mode-slide-btn {
  width: 17.444444444444443vh;
  height: 3.666vh;
  border-radius: 0.444vh;
  font-size: 2vh;
  line-height: 2.3333333333333335vh;
  color: #908f8d;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.active-mode {
  background: #1d1d1b;
  color: #ededed;
}
.histogram {
  width: 100%;
  position: relative;
  padding-bottom: 4.111111111111111vh;
  margin-bottom: 1.6666666666666667vh;
  box-sizing: border-box;
}
.histogram-bg {
  width: 100%;
}
.histogram-line {
  width: 100%;
  display: flex;
  height: 1.8888888888888888vh;
  align-items: center;
  justify-content: flex-end;
  font-size: 1.666vh;
  line-height: 1.888vh;
  color: #908f8d;
  margin-bottom: 1.6666666666666667vh;
}

.histogram-line:last-child {
  margin-bottom: 0;
}
.histogram-line div {
  width: calc(100% - 4.444vh);
  background-image: linear-gradient(
    to right,
    #c4c4c4 60%,
    rgba(255, 255, 255, 0) 0%
  );
  background-position: 0 100%;
  background-size: 3.333vh 0.1111vh;
  background-repeat: repeat-x;
  height: 0.2vh;
  margin-left: 1.1111111111111112vh;
}
.histogram-data-container {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  justify-content: space-around;
  padding-left: 4.444444444444445vh;
  top: 0;
  box-sizing: border-box;
}

.histogram-data-column {
  cursor: pointer;
  height: calc(100% - 0.5555555555555556vh);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 3.25%;
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #129b81;
  border-radius: 0.5555555555555556vh;
}
.active {
  background: #1d1d1b;
}
.active .day-lable {
  color: #ededed;
}
.histogram-data-column div {
  width: 45%;
}
.data-col {
  min-height: 0.1111vh;
  background: #aeccc6;
  border-radius: 3.7777777777777777vh;
  margin-bottom: 1.22vh;
  width: 100% !important;
  max-height: 35.666666666666664vh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.inner-data-col {
  width: 100%;
  background: #129b81;
  border-radius: 0 0 3.7777777777777777vh 3.7777777777777777vh;
}
.bottom-part {
  display: flex;
  flex-direction: column;
  text-align: center;
  box-sizing: border-box;
}
.bottom-part div {
  width: 98%;
  color: #908f8d;
}
.day-lable {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  text-align: center;
  color: #1d1d1b;
  width: 100% !important;
}
.day-lable.day-off {
  color: #e2223b;
}
.day-date {
  font-size: 1.1111111111111112vh;
  line-height: 1.3333333333333333vh;
  color: #908f8d;
  width: 100% !important;
  text-align: center;
}
.big-mode {
  width: 8%;
}
.big-mode .bottom-part {
  width: 18.6% !important;
}
.selected-details {
  width: 100%;
  padding: 1.6666666666666667vh;
  background: #1d1d1b;
  border-radius: 0.8888888888888888vh;
  box-sizing: border-box;
  margin-top: 16px;
}
.details-title {
  font-size: 2.222vh;
  line-height: 2.5555555555555554vh;
  margin-bottom: 1.1111111vh;
  color: #ededed;
}
.stat-row {
  display: flex;
  width: 100%;
}
.stat-row .info-block {
  width: 24.5%;
  padding: 0 2.222vh;
}
.stat-row .info-block:first-child {
  padding-left: 0;
}
.stat-row .info-block:last-child {
  border-left: 0.1111vh solid #908f8d;
  padding-right: 0;
  width: 27%;
}
.stat-row .info-block:nth-child(2) .value {
  color: #aeccc6;
}
.stat-row .info-block:nth-child(3) .value {
  color: #129b81;
}
.lable {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #908f8d;
}
.value {
  font-size: 2.222vh;
  line-height: 2.5555555555555554vh;
  color: #ededed;
}
</style>
